import { render, staticRenderFns } from "./SaldosSalidas.vue?vue&type=template&id=74ff1660&scoped=true"
import script from "./SaldosSalidas.vue?vue&type=script&lang=ts"
export * from "./SaldosSalidas.vue?vue&type=script&lang=ts"
import style0 from "./SaldosSalidas.vue?vue&type=style&index=0&id=74ff1660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff1660",
  null
  
)

export default component.exports